/**
 * @generated SignedSource<<339ee40b05bf3858ec4c3fd0c2e01b15>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ChangeBuilds_buildTypes$data = {
  readonly buildType: ReadonlyArray<{
    readonly rawId: string | null | undefined;
  }> | null | undefined;
  readonly " $fragmentType": "ChangeBuilds_buildTypes";
};
export type ChangeBuilds_buildTypes$key = {
  readonly " $data"?: ChangeBuilds_buildTypes$data;
  readonly " $fragmentSpreads": FragmentRefs<"ChangeBuilds_buildTypes">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ChangeBuilds_buildTypes",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "BuildTypeRest",
      "kind": "LinkedField",
      "name": "buildType",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rawId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "BuildTypes",
  "abstractKey": null
};

(node as any).hash = "59dc9e19dde86cedde57e7b2cba5bf29";

export default node;
